import { NgModule } from '@angular/core';
import { ReleaseNoteComponent } from './release-note.component';
import { Gt2PrimengModule } from '../../modules/gt2-primeng.module';
import { RouterModule } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { authGuard } from '../../gards/auth-guard';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';

const routes = [
  // Routes sans slug pour pouvoir partager la page sans le nom du tenant
  // (ex. https://g-t.app/note-mise-a-jour). Le composant est statique et ne lit
  // pas :shop_uuid, donc aucun contexte tenant n'est requis. `authGuard` limite
  // toutefois l'accès aux utilisateurs authentifiés (sinon redirection login).
  {
    path: AppRoutesName.EN.RELEASE_NOTES,
    component: ReleaseNoteComponent,
    canActivate: [authGuard],
  },
  {
    path: AppRoutesName.FR.RELEASE_NOTES,
    component: ReleaseNoteComponent,
    canActivate: [authGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.RELEASE_NOTES,
    component: ReleaseNoteComponent,
    canActivate: [authGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.RELEASE_NOTES,
    component: ReleaseNoteComponent,
    canActivate: [authGuard],
  },
];

@NgModule({
  declarations: [ReleaseNoteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    MatInputModule,
    Gt2PrimengModule,
    MatButtonModule,
    MatIconModule,
    RouterModule.forChild(routes),
    TranslateModule,
  ],
  exports: [ReleaseNoteComponent],
  providers: [],
})
export class ReleaseNoteModule {}
